import React from 'react';
import styled from 'styled-components';
import { formatPercentage } from '../../../../CommonUtils/formatNumber';
import { BaseFontAwesome, BaseIcon, Icon } from '../../../../CommonComponents/OPL/Icon/Icon';
import { Text } from '../../../../CommonComponents/OPL/Text/Text';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';

interface WrapperProps {
  isPositive: boolean;
}

const Wrapper = styled(Box)<WrapperProps>(({ isPositive, theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  color: isPositive ? theme.colors.success['600'] : theme.colors.error['600'],
  gap: 4,

  [BaseIcon]: {
    color: 'inherit',
  },
  [BaseFontAwesome]: {
    color: 'inherit',
  },
}));

interface Props {
  value: number;
}

export const AccountPerformance = ({ value }: Props) => (
  <Wrapper isPositive={value >= 0}>
    <Icon className={`fa fa-caret-${value < 0 ? 'down' : 'up'}`} />
    <Text color="inherit" fontSize="small">
      {formatPercentage(Math.abs(value), { mantissa: 2 })}
    </Text>
  </Wrapper>
);
